import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCardTitle,{staticClass:"text-h5 secondary white--text"},[_vm._v(" "+_vm._s(_vm.dialogTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }